import { Button, Stack, Typography, styled } from '@mui/material'
import React from 'react'
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch'
import { show } from '@ebay/nice-modal-react'
import ReservedAddressDialog from '@/components/ReservedAddressDialog'
import useDepositAddressByBtc from '@/hooks/useDepositAddressByBtc'
import { useWallet } from '@/components/common/WalletContext'

const Title = styled(Typography)`
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 46px;

  color: rgba(255, 255, 255, 0.9);

  text-shadow: 0px 0px 40px #bfff0b;
`

const StyledButton = styled(Button)`
  background: #bfff0b;
  width: 36px;
  min-width: 36px;
  height: 36px;
  color: black;

  > svg {
    width: 24px;
    height: 24px;
  }

  :hover {
    color: #bfff0b;
  }
`

const Header = () => {
  const { data: depositAddress } = useDepositAddressByBtc()
  const { walletType } = useWallet()
  return (
    <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
      <Title variant="h1">Bridge</Title>
      {walletType !== 'Evm' && (
        <StyledButton
          onClick={() => {
            show(ReservedAddressDialog, { address: depositAddress })
          }}
        >
          <ContentPasteSearchIcon />
        </StyledButton>
      )}
    </Stack>
  )
}

export default Header
